/**
 * TinyMCE init for email-safe admin editors (Vite bundle).
 * Uses imported skins/plugins only — no runtime loads from /admin/... paths.
 */
export const tinymceEmailEditorInit = {
  height: 420,
  menubar: 'edit view insert format table',
  plugins: ['advlist', 'autolink', 'code', 'image', 'link', 'lists', 'preview', 'table'],
  toolbar:
    'undo redo | blocks | bold italic | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | link image table | code preview',
  branding: false,
  promotion: false,
  resize: true,
  skin: false,
  content_css: false,
  relative_urls: false,
  remove_script_host: false,
  convert_urls: false,
  valid_elements:
    'p,br,strong/b,em/i,h1,h2,h3,h4,ul,ol,li,a[href|target|rel],table,thead,tbody,tr,td[colspan|rowspan],th[colspan|rowspan],img[src|alt|width|height],blockquote,hr,span[style],div[style]',
  invalid_elements: 'script,style,iframe,form,input,button,video,svg,object,embed',
};

export const FIRESTORE_INDEX_BUILDING_MESSAGE =
  'Firestore indexes are still building (usually 5–15 minutes after deploy). Refresh shortly; campaign save/edit still works.';

export function getFirestoreIndexStatusMessage(error: unknown): string | null {
  const message = error instanceof Error ? error.message : String(error);
  if (message.includes('index is currently building')) {
    return FIRESTORE_INDEX_BUILDING_MESSAGE;
  }
  if (message.includes('requires an index')) {
    return 'A Firestore composite index is required. Open the link in the browser console or Firebase Console → Firestore → Indexes.';
  }
  return null;
}

export function isFirestoreIndexBuilding(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return message.includes('index is currently building');
}
